<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsSugSelect',
  inheritAttrs: false,
})
</script>
<template>
  <div
    class="tlbs-sug-select"
    :style="style"
  >
    <t-select
      v-bind="$attrs"
      filterable
      :show-arrow="false"
      :teleported="false"
      @search="remoteMethod"
    >
      <t-option
        v-for="(item, index) in options"
        :key="item.label + index"
        :label="item.label"
        :value="item.value"
      />
      <template #empty>
        <div class="t-select__empty">
          {{ props.empty }}
        </div>
      </template>
      <template #prefixIcon>
        <t-icon
          v-if="props.prefixIcon"
          :name="props.prefixIcon"
        />
      </template>
    </t-select>
    <SearchIcon
      v-if="showSearchIcon"
      class="tlbs-sug-icon"
    />
  </div>
</template>

<script lang="ts" setup name="TlbsSugSelect" inheritAttrs="false">
import { SearchIcon } from 'tdesign-icons-vue-next';
import jsonp from 'fetch-jsonp';

const key = 'ATRBZ-3QEN3-WCP3H-YPUPE-H54U6-C4BCG';

interface Option {
  value: string | number | boolean | object;
  label: string;
  subLabel?: string;
}

interface Prop {
  region?: string;
  regionFix?: number;
  empty?: string;
  showSearchIcon?: boolean;
  prefixIcon?: string;
  style?: LooseObject;
}

const props = withDefaults(defineProps<Prop>(), {
  region: '',
  regionFix: 1,
  showSearchIcon: true,
  empty: '搜索无结果',
  prefixIcon: '',
  style: () => ({}),
});

const options = ref<Option[]>([]);
const remoteMethod = async (query: string) => {
  if (query) {
    const suggestionUrl = `https://apis.map.qq.com/ws/place/v1/suggestion?key=${key}&keyword=${query}&region=${props.region}&region_fix=${props.regionFix}&output=jsonp`;
    try {
      const res = await jsonp(suggestionUrl).then((response: any) => response.json());
      if (res && res.status === 0) {
        const { data } = res;
        options.value = data.map((item: any) => ({
          label: item.title,
          value: item,
        }));
      } else {
        console.error('suggestion服务请求出错');
      }
    } catch (err) {
      console.log('json parsing failed', err);
    }
  } else {
    options.value = [];
  }
};
</script>
<style lang="less" scoped>
</style>
